/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Core_DetailsInputs */

const en_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core Details`)
};

const es_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles principales`)
};

const fr_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails principaux`)
};

const de_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerndetails`)
};

const ja_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基本情報`)
};

const zh_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核心详情`)
};

const ar_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التفاصيل الأساسية`)
};

const id_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Inti`)
};

const it_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli Principali`)
};

const ru_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключевые детали`)
};

const pt_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes Principais`)
};

const ko_core_details = /** @type {(inputs: Core_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`핵심 세부 정보`)
};

/**
* | output |
* | --- |
* | "Core Details" |
*
* @param {Core_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const core_details = /** @type {((inputs?: Core_DetailsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Core_DetailsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_core_details(inputs)
	if (locale === "es") return es_core_details(inputs)
	if (locale === "fr") return fr_core_details(inputs)
	if (locale === "de") return de_core_details(inputs)
	if (locale === "ja") return ja_core_details(inputs)
	if (locale === "zh") return zh_core_details(inputs)
	if (locale === "ar") return ar_core_details(inputs)
	if (locale === "id") return id_core_details(inputs)
	if (locale === "it") return it_core_details(inputs)
	if (locale === "ru") return ru_core_details(inputs)
	if (locale === "pt") return pt_core_details(inputs)
	return ko_core_details(inputs)
});